// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__CcjZg","alertIcon":"ConfirmModal_alertIcon__3usJ_"};